import { useEffect } from 'react';

import { useBrowserCompatibilityData } from 'shared/helpers/globals';
import { sendWebViewLinkEvent } from 'shared/helpers/rnBridge';

const interceptLinks = (e: MouseEvent) => {
  if (e.target) {
    const target = e.target as Element;
    const linkTag = target.closest('a');
    const href = linkTag?.getAttribute('href');
    if (href) {
      const url = new URL(href, document.location.href);

      // Have the native app handle the click rather than this web view
      e.preventDefault();
      sendWebViewLinkEvent(url);
    }
  }
};

/** Intercepts href links and sends a message to the mobile webview */
const useWebViewLinkIntercept = () => {
  const { isOpendoorAppEvoWebView } = useBrowserCompatibilityData();
  useEffect(() => {
    if (isOpendoorAppEvoWebView) {
      document.addEventListener('click', interceptLinks);

      return () => document.removeEventListener('click', interceptLinks);
    }
  }, [isOpendoorAppEvoWebView]);
};

/** Intercepts href links and sends a message to the mobile webview */
export const InterceptWebViewLinks = () => {
  useWebViewLinkIntercept();
  return null;
};
